<!-- STATE A: not sealed — orange draft banner -->
<div class="status-banner draft-state" *ngIf="!isSealed">
    <div class="banner-content">
        <!-- Warning icon -->
        <span
            hamIconShapes
            class="banner-icon"
            icon="assets/hamIcons/exclamation-outline.svg"
            [variant]="'orange800'"
            [size]="'regular'"
        ></span>
        <div class="banner-text">
            <div class="banner-title">{{ 'aumico_seal_banner_draft_title' | i18next }}</div>
            <div class="banner-sub">{{ 'aumico_seal_banner_draft_sub' | i18next }}</div>
        </div>
        <div class="banner-actions">
            <button class="banner-btn-primary" (click)="sealClicked.emit()">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
                {{ 'aumico_annual_report_print_seal_report_action' | i18next }}
            </button>
        </div>
    </div>
</div>

<!-- STATE B: sealed — green banner -->
<div class="status-banner sealed-state" *ngIf="isSealed">
    <div class="banner-content">
        <!-- Shield check icon -->
        <span
            hamIconShapes
            class="banner-icon"
            icon="assets/hamIcons/shield-check.svg"
            [variant]="'dark-green'"
            [size]="'xs'"
        ></span>
        <div class="banner-text">
            <div class="banner-title">{{ 'aumico_seal_banner_sealed_title' | i18next }}</div>
            <div class="banner-sub">
                {{ 'aumico_seal_banner_sealed_sub' | i18next : { date: (sealedAt | date : 'dd.MM.yyyy HH:mm'), user: sealedBy } }}
            </div>
        </div>
        <div class="banner-actions">
            <button class="banner-btn-ghost" (click)="auditLogClicked.emit()" [disabled]="!hasSealHistory">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12 6 12 12 16 14"/>
                </svg>
                {{ 'aumico_seal_banner_audit_log' | i18next }}
            </button>
            <button class="banner-btn-ghost" (click)="unsealClicked.emit()">
                <span class="ham-icon icon">
                    <i class="lock-icon"></i>
                </span>
                {{ 'aumico_seal_banner_unseal' | i18next }}
            </button>
        </div>
    </div>
</div>
